/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-20 15:14:05
 * @LastEditors: linxi
 * @LastEditTime: 2024-06-27 13:56:44
 */
import { createAsyncThunk, createSlice, unwrapResult } from '@reduxjs/toolkit'
import _ from 'lodash'
import { api, sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunk, RootThunkApi } from '../../app/store'
import { fromJson } from '../../models/user'
import {
  getAcceptanceModalList,
  getExportBSExcel,
  getExportJJCKExcel,
  getExportJJHKExcel,
  getExportLYCKExcel,
  getExportZYQDExcel,
  getImportExcel,
  getStorageTraceCodeCheck,
  getStorageTraceCodeCheckMulty,
  getSubmitAcceptance,
  getUpdateMarkCode,
  getUpdateMarkCodeMulty,
  ImportExcelParams,
  listExport,
  listExportBody,
  saveInvoiceNbSynchronization,
  saveInvoiceNbSynchronizationBody,
  StorageTraceCodeCheckMultyParams,
  StorageTraceCodeCheckParams,
  stordetailBody,
  storedetailInvoiceNbSave,
  storedetailRemove,
  storedetailSave,
  SubmitAcceptanceParams,
} from '../../services/storedetail'
import {
  getUserList,
  GetUserListParams,
  getUsersInDepartment,
} from '../..//services/user'
import { detailPutstorage } from '../putstorage/putstorageSlice'
const initialState = {
  PutstoreDate: [],
  SelectId: 0,
  UserData: [],
  ListCurrent: 1,
  ListTotal: 0,
}
export const putstoreSlice = createSlice({
  name: 'putstore',
  initialState,
  reducers: {
    setDurgData(state, action) {
      state.PutstoreDate = action.payload
    },
    setListCurrent(state, action) {
      state.ListCurrent = action.payload
    },
    setlistTotal(state, action) {
      state.ListTotal = action.payload
    },
    setSelectId(state, action) {
      state.SelectId = action.payload
    },
    setUserData(state, action) {
      state.UserData = action.payload
    },
    addRow(state, action) {
      state.PutstoreDate = action.payload
    },
    deleteRow(state, action) {
      state.PutstoreDate = action.payload
    },
    changeRow(state, action) {
      state.PutstoreDate = action.payload
    },
  },
})

export const {
  setDurgData,
  setListCurrent,
  setlistTotal,
  setSelectId,
  setUserData,
  addRow,
  deleteRow,
  changeRow,
} = putstoreSlice.actions

//新增
export const saveStoreDetailAsync = createAsyncThunk<
  void,
  stordetailBody,
  RootThunkApi<void>
>('Putstorage/savelist', async (body, api) => {
  return sendAsync(storedetailSave(body), api)
})

//保存发票号
export const saveStoreDetailInvoiceNbAsync = createAsyncThunk<
  void,
  stordetailBody,
  RootThunkApi<void>
>('Putstorage/savelistInvoiceNb', async (body, api) => {
  return sendAsync(storedetailInvoiceNbSave(body), api)
})

//保存发票号向下同步
export const saveInvoiceNbSynchronizationAsync = createAsyncThunk<
  void,
  saveInvoiceNbSynchronizationBody,
  RootThunkApi<void>
>('Putstorage/saveInvoiceNbSynchronizationAsync', async (body, api) => {
  return sendAsync(saveInvoiceNbSynchronization(body), api)
})

//业务人员
export function getUserName(departmentId: string): RootThunk {
  return api(
    getUsersInDepartment(departmentId, undefined),
    (data: any, dispatch) => {
      const users = _.chain(data.records)
        .map((u) => fromJson(u))
        .value()
      dispatch(setUserData(users))
    }
  )
}

export function getAllUserName(params: GetUserListParams): RootThunk {
  return api(getUserList(params), (data: any, dispatch) => {
    const users = _.chain(data.records)
      .map((u) => fromJson(u))
      .value()
    dispatch(setUserData(users))
  })
}

//删除
export function Removestoredetail(id: string, detailId?: number): RootThunk {
  return api(storedetailRemove(id), (data, dispatch) => {
    dispatch(detailPutstorage(detailId as number))
  })
}


// 导入
export const getImportExcelAsync = createAsyncThunk<
  void,
  ImportExcelParams,
  RootThunkApi
>('/commodity/importExcel', async (body, api) => {
  return sendAsync(getImportExcel(body), api)
})

// 领用出库导出
export const getExportLYCKExcelAsync = createAsyncThunk<void, any, RootThunkApi>(
  '/commodity/exportExcel',
  async (body, api) => {
    return sendAsync(getExportLYCKExcel(body), api)
  }
)


//借记出库导出
export const getExportJJCKxcelAsync = createAsyncThunk<void, any, RootThunkApi>(
  '/commodity/exportExcel',
  async (body, api) => {
    return sendAsync(getExportJJCKExcel(body), api)
  }
)

//借记还库导出
export const getExportJJHKExcelAsync = createAsyncThunk<void, any, RootThunkApi>(
  '/commodity/exportExcel',
  async (body, api) => {
    return sendAsync(getExportJJHKExcel(body), api)
  }
)

//中药清斗单导出
export const getExportZYQDExcelAsync = createAsyncThunk<void, any, RootThunkApi>(
  '/commodity/exportExcel',
  async (body, api) => {
    return sendAsync(getExportZYQDExcel(body), api)
  }
)


//报损导出
export const getExportBSExcelAsync = createAsyncThunk<void, any, RootThunkApi>(
  '/commodity/exportExcel',
  async (body, api) => {
    return sendAsync(getExportBSExcel(body), api)
  }
)


// 导出
export const getListExport = createAsyncThunk<void, listExportBody, RootThunkApi>(
  '/commodity/exportExcel',
  async (body, api) => {
    return sendAsync(listExport(body), api)
  }
)

export const RemovestoredetailAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi<void>
>('Putstorage/removelist', async (id, api) => {
  return sendAsync(storedetailRemove(id), api, true)
})

export function getDepartment(params: GetUserListParams): RootThunk {
  return api(getUserList(params), (data: any, dispatch) => {
    const users = _.chain(data.records)
      .map((u) => fromJson(u))
      .value()
    dispatch(setUserData(users))
  })
}

// 验收单
export const getAcceptanceModalListAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>('Putstorage/getAcceptanceModalListAsync', async (id, api) => {
  return sendAsync(getAcceptanceModalList(id), api, true)
})

// 验收单
export const getSubmitAcceptanceAsync = createAsyncThunk<
  void,
  SubmitAcceptanceParams,
  RootThunkApi<void>
>('Putstorage/getSubmitAcceptanceAsync', async (id, api) => {
  return sendAsync(getSubmitAcceptance(id), api, true)
})

//追溯码校验
export const getStorageTraceCodeCheckAsync = createAsyncThunk<void, StorageTraceCodeCheckParams, RootThunkApi>(
  '/traceCode/storageTraceCodeCheck',
  async (params, api) => {
    return sendAsync(getStorageTraceCodeCheck(params), api)
  }
)

// 批量校验追溯码
export const getStorageTraceCodeCheckMultyAsync = createAsyncThunk<void, StorageTraceCodeCheckMultyParams, RootThunkApi>(
  '/traceCode/getStorageTraceCodeCheckMultyAsync',
  async (params, api) => {
    return sendAsync(getStorageTraceCodeCheckMulty(params), api)
  }
)

export const getUpdateMarkCodeAsync = createAsyncThunk<void, StorageTraceCodeCheckParams, RootThunkApi>(
  '/traceCode/updateMarkCode',
  async (body, api) => {
    return sendAsync(getUpdateMarkCode(body), api)
  }
)

// 批量更新追溯码
export const getUpdateMarkCodeMultyAsync = createAsyncThunk<void, StorageTraceCodeCheckMultyParams, RootThunkApi>(
  '/traceCode/getUpdateMarkCodeMultyAsync',
  async (body, api) => {
    return sendAsync(getUpdateMarkCodeMulty(body), api)
  }
)


export const selectorPutstoreData = (state: RootState) =>
  state.putstore.PutstoreDate

export const selectstoreId = (state: RootState) => state.putstore.SelectId

export const sleectUserData = (state: RootState) => state.putstore.UserData

export default putstoreSlice.reducer
